import React from 'react'

import Divider from '@/components/Checkout/Wrapper/Divider'
import type { IApplication } from '@/apis/apps/interfaces'

import PaymentErrors from '../Errors'
import ContentLoader from './ContentLoader'
import PaymentSummary from './PaymentSummary'
import PurchaseItem from './PurchaseItem'
import ActivationProductAlert from './ActivationProductAlert'

type Props = {
  item: IApplication
  isActivationRequired: boolean
  isLoading: boolean
}

const PurchaseModalContent = ({
  item,
  isActivationRequired,
  isLoading,
}: Props) => {
  if (isLoading) {
    return <ContentLoader />
  }

  if (isActivationRequired) {
    return (
      <>
        <ActivationProductAlert />
        <PurchaseItem item={item} hidePicker />
      </>
    )
  }

  return (
    <>
      <PaymentErrors />
      <PurchaseItem item={item} />
      <Divider />
      <PaymentSummary />
    </>
  )
}

export default PurchaseModalContent
